<template lang="">
  <div class="container" @click="close()">
    <div class="mains">
      <transition name="transition-drop">
        <div class="main" v-show="show1" @click.stop>
          <div class="top">
            <div class="select">
              <Input
                v-model="selectVal"
                @on-search="search()"
                search
                placeholder="输入标题"
              />
            </div>
          </div>
          <el-empty description="没有数据哦！" v-if="pageData.length == 0" />
          <Table
            border
            :columns="columns"
            :data="pageData"
            style="width: 100%; height: 100%"
            v-if="pageData.length !== 0"
          >
            <template #name="{ row }">
              <strong>{{ row.name }}</strong>
            </template>
            <template #action="{ row, index }">
              <Button style="margin-right: 5px" @click="select(index)"
                >选择</Button
              >
            </template>
          </Table>
          <!-- 分页 -->
          <Page
            class="page"
            :modelValue="pages"
            :total="allPage"
            simple
            @on-change="page"
          />
        </div>
      </transition>
    </div>
  </div>
</template>
<script>
import { GetDealerList, DelDealerList } from "@/api/index";
export default {
  data() {
    return {
      selectVal: "",
      show1: false,
      columns: [
        {
          title: "企业代码",
          key: "clientCode",
          width: 100,
        },
        {
          title: "代理商编号",
          key: "u_code",
          width: 200,
        },
        {
          title: "代理商名称",
          key: "u_name",
          width: 200,
        },
        {
          title: "手机号",
          key: "u_phone",
          width: 200,
        },
        {
          title: "销售区域",
          key: "u_area",
          width: 200,
        },
        {
          title: "添加时间",
          key: "time",
          width: 200,
        },
        {
          title: "备注",
          key: "remark",
          minWidth: 200,
        },
        {
          title: " ",
          slot: "action",
          width: 100,
          align: "center",
          fixed: "right",
        },
      ],
      // 分页后的数据
      pageData: [],
      pages: 1,
      allPage: 1,
      index: "",
    };
  },
  mounted() { },
  watch: {},
  created() {
    clearTimeout(t1);
    var t1 = setTimeout(() => {
      this.show1 = true;
    }, 100);

    let control = this.$store.state.control;
    if (control !== "1") {
      this.columns = this.columns.filter((p, key) => {
        if (p.title !== "企业代码") {
          return p;
        }
      });
    }
    this.getDealers()
  },
  methods: {
    search() {
      this.getDealers()
    },
    // 获取经销商资料
    getDealers() {
      GetDealerList({
        page: this.pages,
        pagesize: 10,
        name: this.selectVal
      }).then((res) => {
        this.pageData = res.list
        this.allPage = res.size
      });
    },
    // 取消本弹窗
    close() {
      this.$emit("closeDealer", false);
    },
    // 选择 按钮
    select(index) {
      this.$emit("Value", this.pageData[index]);
      this.close()
    },
    // 分页过滤
    page(i) {
      this.pages = i;
      this.getDealers()
    },
  },
};
</script>
<style scoped >
.mains {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100vh;
  box-sizing: border-box;
  padding: 10px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background: rgba(0, 0, 0, 0.4);
  z-index: 99999999;
}

.top {
  width: 100%;
  background: white;
  padding: 15px;
}


.select {
  margin-left: 10px;
}

.main {
  background: white;
  display: flex;
  flex-direction: column;
  align-items: center;
  box-sizing: border-box;
  padding: 10px;
  width: 950px;
  height: auto;
  border-radius: 10px;
}

.page {
  margin-top: 20px;
  margin-bottom: 20px;
}
</style>
